module.exports = "/_next/static/images/c336a53363623716d222bacc0a1bd1d2-pen@mobile320.jpg";